import logo from './logo.svg';
import './App.css';
import Auth from './Components/Auth/Auth';
import 'semantic-ui-css/semantic.min.css';
function App() {
  return (
    <div >
      <Auth />
    </div>

  );
}

export default App;
